import {Injectable} from '@angular/core';
import {forkJoin as observableForkJoin, Observable, of as observableOf} from 'rxjs';

import {Resource} from '../model/resource.model';
import {Right} from '../model/right.model';

export let mockResources = [
  new Resource(1, '/sensors'),
  new Resource(2, '/sensors/observations'),
  new Resource(3, '/sensors/checks'),
  new Resource(4, '/sensors/publishing'),
  new Resource(5, '/sensors/csvexport'),
  new Resource(6, '/map'),
  new Resource(7, '/imports/rws'),
  new Resource(8, '/imports/osr'),
  new Resource(9, '/upload/astro'),
  new Resource(10, '/external-interfaces'),
  new Resource(11, '/imports'),
  new Resource(12, '/watson'),
  new Resource(13, '/alerts'),
];

export let mockRights = [
  new Right(1, 'readAll'),
  new Right(2, 'readOne'),
  new Right(3, 'create'),
  new Right(4, 'update'),
  new Right(5, 'delete'),
];

export let mockResourceRights = [
  [
    {
      resource: mockResources[0],
      rights: mockRights,
    },
    {
      resource: mockResources[1],
      rights: mockRights,
    },
    {
      resource: mockResources[2],
      rights: [mockRights[0], mockRights[1], mockRights[3]],
    },
    {
      resource: mockResources[3],
      rights: mockRights,
    },
    {
      resource: mockResources[4],
      rights: mockRights,
    },
    {
      resource: mockResources[5],
      rights: mockRights,
    },
    {
      resource: mockResources[6],
      rights: mockRights,
    },
    {
      resource: mockResources[7],
      rights: mockRights,
    },
    {
      resource: mockResources[8],
      rights: mockRights,
    },
    {
      resource: mockResources[9],
      rights: mockRights,
    },
    {
      resource: mockResources[10],
      rights: mockRights,
    },
    {
      resource: mockResources[11],
      rights: mockRights,
    },
    {
      resource: mockResources[12],
      rights: mockRights,
    },
  ],
  [
    {
      resource: mockResources[0],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[1],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[2],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[5],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[6],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[7],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[8],
      rights: [mockRights[0], mockRights[1]],
    },
    {
      resource: mockResources[9],
      rights: mockRights,
    },
    {
      resource: mockResources[10],
      rights: mockRights,
    },
  ],
];

export let mockRoles = [
  {
    id: 1,
    name: 'HM_SensorMgr',
    resourceRights: mockResourceRights[0],
  },
  {
    id: 2,
    name: 'HM_Guest',
    resourceRights: mockResourceRights[1],

  },
];

@Injectable()
export class ResourceRightsService {

  public getRoles(names: string[]): Observable<any> {
    const roles: Array<Observable<any>> = [];

    for (const roleName of names) {
      switch (roleName) {
        case 'HM_SensorMgr': {
          roles.push(observableOf(mockRoles[0]));
          break;
        }
        case 'HM_Guest': {
          roles.push(observableOf(mockRoles[1]));
          break;
        }
      }
    }

    return observableForkJoin(roles);
  }
}
